module.exports = __webpack_public_path__ + "static/WomanSportscoat-f900b54dc8943e6652e0d9865ab1aa73.png";